export const OTHER_EVENTS = [
    {
        title: 'FHS',
        url: '/',
        target: false
    },
    {
        title: 'FHS World',
        url: '/world',
        target: false
    },
    {
        title: 'FHS Saudi Arabia',
        url: '/sa',
        target: false
    },
    {
        title: 'FHS Africa',
        url: '/africa',
        target: false
    },
    {
        title: 'FHS Egypt',
        url: '/egypt',
        target: false
    },
    {
        title: 'FHS Living',
        url: '/living',
        target: false
    },
    {
        title: 'AviaDev',
        url: 'https://www.aviadev.com/',
        target: true
    },
    {
        title: 'SAHIC',
        url: 'https://www.sahic.com/',
        target: true
    },
    
]